import {
  FETCH_ALL_CLIENT_TYPES,
} from './../../mutation-types';

export default {
  [FETCH_ALL_CLIENT_TYPES](state, clientTypes) {
    state.all = clientTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/clientTypes/mutations.js